var _rect, _rect2, _path, _line, _path2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 70,
    viewBox: "0 0 124 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.625,
    y: 1.4375,
    width: 68,
    height: 9,
    rx: 0.5,
    transform: "rotate(90 9.625 1.4375)",
    fill: "#C8D9FF",
    stroke: "#4680FF",
    strokeDasharray: "2 2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 123.375,
    y: 0.5625,
    width: 26,
    height: 96,
    rx: 1.5,
    transform: "rotate(90 123.375 0.5625)",
    fill: "#C8D9FF",
    stroke: "#4680FF",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.727 20.2175C34.8537 20.2175 34.9804 20.1708 35.0804 20.0708L39.427 15.7242C40.1337 15.0175 40.1337 13.8575 39.427 13.1508L35.0804 8.80418C34.887 8.61085 34.567 8.61085 34.3737 8.80418C34.1804 8.99751 34.1804 9.31751 34.3737 9.51085L38.7204 13.8575C39.0404 14.1775 39.0404 14.6975 38.7204 15.0175L34.3737 19.3642C34.1804 19.5575 34.1804 19.8775 34.3737 20.0708C34.4737 20.1642 34.6004 20.2175 34.727 20.2175Z",
    fill: "#DC2626"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 107,
    y1: 14.5,
    x2: 42,
    y2: 14.5,
    stroke: "#DC2626",
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.726 8.65749C116.599 8.65749 116.473 8.70415 116.373 8.80415L112.026 13.1508C111.319 13.8575 111.319 15.0175 112.026 15.7242L116.373 20.0708C116.566 20.2642 116.886 20.2642 117.079 20.0708C117.273 19.8775 117.273 19.5575 117.079 19.3642L112.733 15.0175C112.413 14.6975 112.413 14.1775 112.733 13.8575L117.079 9.51082C117.273 9.31749 117.273 8.99749 117.079 8.80415C116.979 8.71082 116.853 8.65749 116.726 8.65749Z",
    fill: "#DC2626"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 11,
    height: 96,
    rx: 0.5,
    transform: "matrix(3.39012e-08 -1 -1 -5.63605e-08 121.875 68.0625)",
    fill: "#C8D9FF",
    stroke: "#4680FF",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/container.d2c46ca4f4d05f670d90667626c26961.svg";
export { ForwardRef as ReactComponent };